import qualityEventsHelpers from '../quality-events.helpers';

export const THANK_YOU_PAGE_QUALITY_EVENTS = {
    purchaseBuyNow() {
        qualityEventsHelpers.track({
            type: 'purchase_buy_now'
        });
    },
    downloadPurchasedMaterial(materialId: number): Promise<void> {
        return qualityEventsHelpers.track({
            type: 'download-purchased-material-click',
            extra: JSON.stringify({
                materialId,
                source: JSON.stringify(window.location.href)
            })
        });
    },
    purchase(items: OrderItems[], details: OrderDetails) {
        const materials = items.map((item) => {
            item.material.purchase_id = details.id;
            item.material.discount = item.discount;
            item.material.finalPrice = item.finalPrice;

            return item.material;
        });

        qualityEventsHelpers.trackMaterialList(qualityEventsHelpers.extractPurchasedMaterialsData(materials), {
            source: 'catalog',
            type: 'purchase'
        });
    }
};
